import { UserRoles } from '@/enums';
import { Reports } from '@/modules/reports/types';
import { all_roles } from '@/utils';

const access_roles = {
  [Reports.Pages.REPORTS]: all_roles,
  [Reports.Pages.REPORT_ORDERS_DETAIL]: all_roles,
  [Reports.Pages.REPORT_SALES_DETAIL]: all_roles,
  [Reports.Pages.REPORTS_MUTUAL_DETAIL]: all_roles,
  [Reports.Pages.REPORTS_REPAIRS_DETAIL]: all_roles,
  [Reports.Pages.REPORTS_SERVICE_DETAIL]: all_roles,
};

export default access_roles;
